import API from './api';
import { exportResults } from '../utils/index';
import { HTTP } from '../config/http-common';

export default class Chapters extends API {
    duplicateChapter = async (body) => exportResults(await HTTP.post(`${this.ROUTE}/duplicate`, body));
}
